export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_05.c4e5dfb8.jpg";